module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-S-drill-received-shadow.4bb8b512.png";